import React from 'react';

interface PageHeaderProps {
  title: string;
  subtitle?: string;
  actions?: React.ReactNode;
}

export const PageHeader: React.FC<PageHeaderProps> = ({ title, subtitle, actions }) => {
  return (
    <div className="admin-header">
      <div>
        <h1 className="admin-header-title">{title}</h1>
        {subtitle && <p style={{ fontSize: '0.85rem', color: 'var(--admin-text-muted)', marginTop: 4 }}>{subtitle}</p>}
      </div>
      {actions && <div className="admin-header-actions">{actions}</div>}
    </div>
  );
};

export default PageHeader;
